import { useTranslation } from 'react-i18next';
import { Avatar, Button, Col, Collapse, CollapseProps, Drawer, Form, message, Modal, Row, Space, Table, Typography } from 'antd';
import React, { useEffect, useState } from 'react';
import FormItemDropdown from "../../../../components/form-dropdown/FormItemDropdown";
import FormInput from "../../../../components/form-input/FormInput";
import { CloseOutlined, ExclamationCircleOutlined, SaveOutlined } from '@ant-design/icons';
import { RuleObject } from 'antd/es/form';
import { StoreValue } from 'antd/es/form/interface';
import _, { isEmpty } from 'lodash';
import { getRoles } from '../../../../service/list-account-users/listAccountUsersApi';
import { createMinistryAccount, getDetailMinistryAccount, getManagementAgencys, getUserMinistry, updateAccountMinistry } from '../../../../service/list-acoount-ministry/listAccountMinistry';
import { regexEmail, regexPassword } from '../../../../utils/regex';
import { getManageUniversities } from '../../../user-info/account/services';

type Props = {
  open: boolean
  handleClose: () => void
  fetchData: () => void
  detailData: any
  isEdit: boolean;

}
interface University {
  id: number;
  uuid: string;
  name: string;
  canManage: boolean;
  logo?: string | null;
  children?: University[];
  isDaiHoc: boolean;
  universityId: number;
}
const FormCreateMinistry = (props: Props) => {
  const { t } = useTranslation();
  const { open, handleClose, fetchData, detailData, isEdit = false } = props
  const [form] = Form.useForm()
  const { Panel } = Collapse;
  const [status, setStatus] = useState<number>(1)
  const [listEnterPrise, setListEnterPrise] = useState<any>([])
  const [listUserMinistry, setListUserMinistry] = useState<any>([])
  const [listRole, setListRole] = useState<any>([]);
  const [dataDetail, setDataDetail] = useState<any>({})
  const [dataSource, setDataSource] = useState<University[]>([]);
  const [expandedRowKeys, setExpandedRowKeys] = useState<any[]>([]);
  const [selectedRowKeys, setSelectedRowKeys] = useState<any[]>([]);

  const validations = {
    phone: {
      required: true,
      message: t("Vui lòng nhập số điện thoại", "Vui lòng nhập số điện thoại")
    },
    enterprise: {
      required: true,
      message: t("Vui lòng chọn giảng viên", "Vui lòng chọn giảng viên")
    },
    emailContact: [
      {
        required: true,
        message: t("Vui lòng nhập địa chỉ email", "Vui lòng nhập địa chỉ email")
      },
      ({ getFieldValue }: { getFieldValue: (name: string) => StoreValue }) => ({
        validator: (_: unknown, value: any) => {
          if (!isEmpty(value) && !value.match(new RegExp(regexEmail))) {
            return Promise.reject(
              new Error(t("Định dạng email không đúng, vui lòng nhâp lại", "Định dạng email không đúng, vui lòng nhâp lại"))
            );
          }
          return Promise.resolve();
        },
      }),
    ],
    trainingFacility: {
      required: true,
      message: t("Vui lòng chọn cơ sở đào tạo", "Vui lòng chọn cơ sở đào tạo")
    },
    emailLogin: [
      {
        required: true,
        message: t("Vui lòng nhập địa chỉ email", "Vui lòng nhập địa chỉ email")
      },
      ({ getFieldValue }: { getFieldValue: (name: string) => StoreValue }) => ({
        validator: (_: unknown, value: any) => {
          if (!isEmpty(value) && !value.match(new RegExp(regexEmail))) {
            return Promise.reject(
              new Error(t("Định dạng email không đúng, vui lòng nhâp lại", "Định dạng email không đúng, vui lòng nhâp lại"))
            );
          }
          return Promise.resolve();
        },
      }),
    ],
    roleLogin: {
      required: true,
      message: t("Vui lòng chọn vai trò", "Vui lòng chọn vai trò")
    },
    passwordLogin: [
      {
        required: dataDetail?.id ? false : true,
        message: t("Vui lòng nhập mật khẩu", "Vui lòng nhập mật khẩu"),
      },
      {
        min: 8,
        max: 25,
        message: t("Độ dài mật khẩu từ 8-25 ký tự.", "Độ dài mật khẩu từ 8-25 ký tự."),
      },
      {
        pattern: regexPassword,
        message:
          t("Mật khẩu phải bao gồm chữ hoa, chữ thường, số và ký tự đặc biệt, và có độ dài từ 8-25 ký tự.", "Mật khẩu phải bao gồm chữ hoa, chữ thường, số và ký tự đặc biệt, và có độ dài từ 8-25 ký tự."),
      },
      ({ getFieldValue }: { getFieldValue: (name: string) => StoreValue }) => ({
        validator(_: RuleObject, value: StoreValue) {
          if (value && getFieldValue("oldPassword") === value) {
            return Promise.reject(
              new Error(t("Mật khẩu mới phải khác mật khẩu hiện tại.", "Mật khẩu mới phải khác mật khẩu hiện tại."))
            );
          }
          return Promise.resolve();
        },
      }),
    ],
    passwordLoginConfirm: [
      {
        required: dataDetail?.id ? false : true,
        message: t("Vui lòng xác nhập mật khẩu mới", "Vui lòng xác nhập mật khẩu mới"),
      },
      ({ getFieldValue }: { getFieldValue: (name: string) => StoreValue }) => ({
        validator(_: RuleObject, value: StoreValue) {
          if (!isEmpty(value)) {
            if (getFieldValue("passwordLogin") === value) {
              return Promise.resolve();
            }
            return Promise.reject(
              new Error(t("Mật khẩu không khớp.", "Mật khẩu không khớp."))
            );
          }
          return Promise.resolve();
        },
      }),
    ],
  }

  const createAccount = async (values: any) => {
    const data = {
      userProfileId: values.enterprise,
      username: values.emailLogin,
      password: values.passwordLogin,
      confirmPassword: values.passwordLoginConfirm,
      status: status === 1 ? true : false,
      roleIds: _.isArray(values.roleLogin) ? values.roleLogin : [values.roleLogin],
      universityIds: selectedRowKeys
    }
    if (dataDetail?.id) {
      await updateAccountMinistry(detailData?.id, data).then((res) => {
        if (res.status === 200) {
          message.success(t("Sửa tài khoản thành công", "Sửa tài khoản thành công"))
        }
      })
    } else {
      await createMinistryAccount(data).then((res) => {
        if (res.status === 200) {
          message.success(t("Tạo tài khoản thành công", "Tạo tài khoản thành công"))
        }
      })
    }
    handleClose()
    form.resetFields()
    fetchData()
    setDataDetail([])
  }

  const getListUserMinistry = async (value: any) => {
    if (!value) {
      setListUserMinistry([])
      return
    }
    await getUserMinistry(value).then((res) => {
      if (res.status === 200) {
        setListUserMinistry(res.data?.data)
      }
    })
  }

  //lay danh sach vai trò
  const getRole = async () => {
    await getRoles()
      .then((res) => {
        const { data } = res.data
        setListRole(data)
      })
  }

  const blockOne = () => (
    <>
      <Row gutter={24}>
        <Col span={12}>
          <Form.Item name="trainingFacility" label={t("Đơn vị", "Đơn vị")} rules={[validations.trainingFacility]}>
            <FormItemDropdown
              options={listEnterPrise}
              allowClear={true}
              placeholder={t("Chọn đơn vị", "Chọn đơn vị")}
              onChange={getListUserMinistry}
            />
          </Form.Item>
        </Col>
        <Col span={12}>
          <Form.Item name="enterprise" label={t("Người dùng", "Người dùng")} rules={[validations.enterprise]}>
            <FormItemDropdown
              options={listUserMinistry}
              allowClear={true}
              placeholder={t("Chọn người dùng", "Chọn người dùng")}
            />
          </Form.Item>
        </Col>
      </Row>
    </>
  )

  const blockTwo = () => (
    <>
      <Row gutter={24}>
        <Col span={12}>
          <Form.Item name="emailLogin" label={t("Email đăng nhập", "Email đăng nhập")} rules={validations.emailLogin}>
            <FormInput
              placeholder={t("Nhập email đăng nhập", "Nhập email đăng nhập")}
              autoComplete="new-password"
            />
          </Form.Item>
        </Col>
        <Col span={12}>
          <Form.Item name="roleLogin" label={t("Vai trò", "Vai trò")} rules={[validations.roleLogin]}>
            <FormItemDropdown
              options={listRole}
              allowClear={true}
              placeholder={t("Chọn vai trò", "Chọn vai trò")}
              modeDropdown="multiple"
            />
          </Form.Item>
        </Col>
      </Row>
      {
        dataDetail?.id ? null :
          <Row gutter={24} className="">
            <Col span={12}>
              <Form.Item name="passwordLogin" label={t("Mật khẩu", "Mật khẩu")} rules={validations.passwordLogin}>
                <FormInput
                  placeholder={t("Nhập mật khẩu cho tài khoản", "Nhập mật khẩu cho tài khoản")}
                  passwordInput={true}
                  style={{ height: '32px' }}
                  autoComplete="new-password"
                />
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item name="passwordLoginConfirm" label={t("Xác nhận mật khẩu", "Xác nhận mật khẩu")} rules={validations.passwordLoginConfirm}>
                <FormInput
                  placeholder={t("Xác nhận mật khẩu cho tài khoản", "Xác nhận mật khẩu cho tài khoản")}
                  passwordInput={true}
                  style={{ height: '32px' }}
                />
              </Form.Item>
            </Col>
          </Row>
      }
      <Row gutter={24} className="">
        <Col span={24}>
          <Form.Item name="status" label={t("Trạng thái", "Trạng thái")}>
            <Space.Compact block>
              <Button className={status === 1 ? 'active' : ''} onClick={() => setStatus(1)}>{t("Mở khóa", "Mở khóa")}</Button>
              <Button className={status === 2 ? 'active' : ''} onClick={() => setStatus(2)}>{t("Khóa", "Khóa")}</Button>
            </Space.Compact>
          </Form.Item>
        </Col>
      </Row>
    </>
  )


  const getListEnterprise = async () => {
    await getManagementAgencys().then((res) => {
      if (res.status === 200) {
        const arr = res.data?.data
        setListEnterPrise(arr)
      }
    })
  }
  const findAllSelectedKeys = (universities: University[]): number[] => {
    let keys: number[] = [];
    universities.forEach((uni) => {
      keys.push(uni.id);
      if (uni.children && uni.children.length > 0) {
        keys = keys.concat(findAllSelectedKeys(uni.children));
      }
    });
    return keys;
  };

  //lay chi tiet tai khoản giảng viên
  const getListDataDetail = async () => {
    await getDetailMinistryAccount(detailData?.id).then((res) => {
      if (res.status === 200) {
        const detail = res.data?.data
        setDataDetail(res.data?.data)
        form.setFieldsValue({
          managementAgency: detail?.universityRegisterId ? detail?.universityRegisterId : undefined,
          contactPeople: detail?.userContact,
          contactRolePeople: detail?.userContactPositionId,
          phone: detail?.userContactPhone,
          emailContact: detail?.userContactEmail,
          trainingFacility: detail?.unitId,
          emailLogin: detail?.username,
          enterprise: detail?.userProfileId,
          roleLogin: detail?.roles?.map((item: any) => { return item.id }),
        })
        getListUserMinistry(detail?.unitId)
        setStatus(detail?.isActive ? 1 : 2)
        const selectedKeys = findAllSelectedKeys(detail?.managedEnterprises || []);
        setSelectedRowKeys(selectedKeys);
      }
    })
  }

  useEffect(() => {
    if (open) {
      getListEnterprise()
      getRole()
    }
    if (!isEdit) {
      setSelectedRowKeys([]);

    }
  }, [open])

  useEffect(() => {
    if (detailData?.id) {
      getListDataDetail();
    } else {
      form.resetFields()
    }
  }, [detailData])

  const clearFilter = () => {
    form.resetFields()
    setDataDetail([])
    handleClose()
  }

  const processChildren = (data: University[]): University[] => {
    return data.map((item) => {
      const newItem = { ...item };
      if (newItem.children && newItem.children.length === 0) {
        delete newItem.children;
      } else if (newItem.children) {
        newItem.children = processChildren(newItem.children);
      }
      return newItem;
    });
  };
  const generateTreeData = (nodes: University[]): any[] => {
    return nodes?.map((node) => {
      const { id, name, logo, children } = node;

      return {
        title: (
          <Space>
            <Avatar shape="square" size="small" src={logo} />
            {name}
          </Space>
        ),
        value: id,
        dataRef: node,
        children: children && children.length > 0 ? generateTreeData(children) : undefined,
      };
    });
  };

  const findNodeByUuid = (nodes: University[], id: number): University | undefined => {
    for (const node of nodes) {
      if (node.id === id) {
        return node;
      }
      if (node.children && node.children.length > 0) {
        const found = findNodeByUuid(node.children, id);
        if (found) {
          return found;
        }
      }
    }
    return undefined;
  };
  useEffect(() => {
    const fetchData = async () => {
      const res = await getManageUniversities({});
      const formattedData = processChildren(
        res.data.data.map((item: any) => ({
          ...item,
          key: item.id,
          children: item.children?.map((child: any) => ({
            ...child,
            key: child.id,
          })),
        }))
      );
      setDataSource(formattedData);

      const defaultExpandedKeys = formattedData
        .filter((item: any) => item.children)
        .map((item: any) => item.id);
      setExpandedRowKeys(defaultExpandedKeys);
    };
    if (open) fetchData()
  }, [open])



  const columns = [
    {
      title: t('Tên trường', 'Tên trường'),
      dataIndex: 'name',
      key: 'name',
      render: (text: string, record: University) => (
        <div className="flex align-center gap-8">
          <Avatar shape="square" size="small" src={record?.logo} />
          {text}
        </div>
      ),
    },
    {
      title: t('Mã trường', 'Mã trường'),
      dataIndex: 'code',
      key: 'code',
    },
    {
      title: t('Tên tiếng anh', 'Tên tiếng anh'),
      dataIndex: 'nameEn',
      key: 'nameEn',
    },
  ];

  const handleExpand = (expanded: boolean, record: University) => {
    setExpandedRowKeys((prevKeys) =>
      expanded ? [...prevKeys, record.id] : prevKeys.filter((key) => key !== record.id)
    );
  };

  const handleRowSelectionChange = (selectedKeys: React.Key[], selectedRows: University[]) => {
    setSelectedRowKeys(selectedKeys as string[]);
  };

  const rowSelection = {
    selectedRowKeys,
    onChange: handleRowSelectionChange,
    checkStrictly: false,
  };


  const items: CollapseProps['items'] = [
    {
      key: '1',
      label: <Typography.Title level={5}><strong>{t("Thông tin người dùng", "Thông tin người dùng")}</strong></Typography.Title>,
      children: blockOne(),
    },
    {
      key: '2',
      label: <Typography.Title level={5}><strong>{t("Thông tin tài khoản", "Thông tin tài khoản")}</strong></Typography.Title>,
      children: blockTwo(),
    },
    {
      key: '3',
      label: <Typography.Title level={5}><strong>{t("Trường quản trị", "Trường quản trị")}</strong></Typography.Title>,
      children: <Table
        columns={columns}
        dataSource={dataSource}
        rowKey="id"
        rowSelection={rowSelection}
        expandable={{
          expandedRowKeys,
          onExpand: handleExpand,
          rowExpandable: (record) => !!record.children?.length
        }}
        pagination={{ pageSize: 5 }}
      />,
    },
  ];
  return (
    <>
      <Form.Provider onFormFinish={(name, { values, forms }) => {
        if (name === "add-chapter") {
          Modal.confirm({
            title: t("Xác nhận tạo tài khoản", "Xác nhận tạo tài khoản"),
            content: t("Đảm bảo tất cả các thông tin liên quan đã được kiểm tra trước khi xác nhận.", "Đảm bảo tất cả các thông tin liên quan đã được kiểm tra trước khi xác nhận."),
            onOk: () => {
              createAccount(values)
            },
            okText: t("Xác nhận", "Xác nhận"),
            cancelText: t("Huỷ bỏ", "Huỷ bỏ"),
            centered: true,
            icon: <ExclamationCircleOutlined style={{ color: "#1677FF" }} />,
            footer: (_, { OkBtn, CancelBtn }) => (
              <>
                <CancelBtn />
                <OkBtn />
              </>
            ),
          });
        }
      }}>
        <Drawer
          title={`${isEdit ? t("Sửa", "Sửa") : t("Tạo", "Tạo")} ${t("tài khoản người dùng cấp bộ", "tài khoản người dùng cấp bộ")}`}
          open={open}
          onClose={clearFilter}
          width={736}
          extra={
            <Space>
              <Button onClick={() => {
                form.resetFields()
                clearFilter()
              }} className="btn btn-outlined">
                <CloseOutlined />
                <Typography.Text>{t("Hủy", "Hủy")}</Typography.Text>
              </Button>
              <Button className="btn btn-primary"
                onClick={() => form.submit()
                }>
                <SaveOutlined />
                <Typography.Text>{t("Lưu", "Lưu")}</Typography.Text>
              </Button>
            </Space>
          }
        >
          <Form
            className="create-form-facility-management"
            layout={"vertical"}
            form={form}
            name="add-chapter"
            autoComplete='off'
            initialValues={{ emailLogin: '', passwordLogin: '' }}
          >
            <Collapse defaultActiveKey={['1', '2', '3']} ghost items={items} />

          </Form>
        </Drawer>
      </Form.Provider>
    </>
  );
};

export default FormCreateMinistry;
